import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../src/img/logo.png";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="h-[80px] bg-[#07031C] flex px-4 justify-between items-center">
      <div className="mt-[-20px]">
        <img src={Logo} alt="logo" className="h-10 w-auto" />
      </div>
      <div className="hidden md:flex text-white justify-between gap-8">
        <Link
          to="/"
          className="text-[14px] font-[500] leading-[19px] text-[#D4F5F9] font-['Istok']"
        >
          Home
        </Link>
        <Link
          to="/aboutus"
          className="text-[16px] font-[500] leading-[19px] text-[#D4F5F9] font-['Istok']"
        >
          About Us
        </Link>
        <Link to="/contactus" className="text-[16px] font-[500] leading-[19px] text-[#D4F5F9] font-['Istok']">
          Contact Us
        </Link>
        <Link
          to="/privacy"
          className="text-[16px] font-[500] leading-[19px] text-[#D4F5F9] font-['Istok']"
        >
          Privacy Policy
        </Link>
      </div>
      <div className="hidden md:flex text-white justify-between gap-2">
        <Link
          to="/login"
          className="text-[16px] font-[500] leading-[19px] text-[#00001A] h-[38px] w-[120px] bg-[#D9D9D9] items-center justify-center flex rounded-[40px] font-['Istok']"
        >
          Log In
        </Link>
        <Link  to="/signup" className="text-[16px] font-[500] leading-[19px] text-[#00001A] h-[38px] w-[120px] bg-[#F2C493] items-center justify-center flex rounded-[40px] font-['Istok']">
          Sign Up
        </Link>
      </div>
      <div className="md:hidden flex items-center">
        <button
          className="text-white focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </div>
      {isOpen && (
        <div className="absolute top-[80px] left-0 w-full bg-[#00001A]  gap-6 flex flex-col items-center text-white pb-[20px]">
         
           <div className="flex  justify-between w-full pl-8 pr-8">

          <Link
            to="/login"
            className="py-2 text-[16px]  h-[53px] font-[500] text-[#00001A] bg-[#D4F5F9] w-[48%] flex items-center justify-center rounded-[15px] font-['Istok']"
          >
            Log In
          </Link>
         <Link
  to="/signup"
  className="py-2 h-[53px] w-[48%] text-[12px] font-[500] text-white flex items-center justify-center rounded-[15px] font-['Istok']"
  style={{
    background: "linear-gradient(90.07deg, #DFBD69 0%, #241D49 49.94%)",
  }}
>
  Sign Up
</Link>


          </div>

          <div className="w-full  pl-8 pr-8 grid grid-cols-1 gap-4">
          <Link
            to="/"
            className="py-2 text-[16px]   font-[500] text-[#D4F5F9] font-lato"
          >
            Home
          </Link>
          <Link
            to="/aboutus"
            className="py-2 text-[16px] font-[500] text-[#D4F5F9] font-lato"
          >
            About Us
          </Link>
          <Link to="/contactus" className="py-2 text-[16px] font-[500] text-[#D4F5F9] font-lato">
            Contact Us
          </Link>
          <Link
            to="/privacy"
            className="py-2 text-[16px] font-[500] text-[#D4F5F9] font-lato"
          >
            Privacy Policy
          </Link>
          </div>
        
        </div>
      )}
    </div>
  );
}

export default Navbar;
